import * as React from "react"
const Horror = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M18.101 19.238c0 1.483-.802 2.687-1.791 2.687-.99 0-1.792-1.204-1.792-2.687 0-1.484.802-2.688 1.791-2.688.99 0 1.792 1.204 1.792 2.688Zm10.75 0c0 1.483-.802 2.687-1.791 2.687-.99 0-1.792-1.204-1.792-2.687 0-1.484.802-2.688 1.791-2.688.99 0 1.792 1.204 1.792 2.688Z"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M21.684 2.665c-10.674 0-19.26 8.903-19.26 19.798v13.3c0 3.309 3.426 5.595 6.438 4.045a3.709 3.709 0 0 1 3.814.245 6.4 6.4 0 0 0 7.267 0l.632-.433a1.945 1.945 0 0 1 2.219 0l.632.433a6.4 6.4 0 0 0 7.267 0 3.708 3.708 0 0 1 3.816-.245c3.01 1.55 6.436-.738 6.436-4.046V22.465c0-10.897-8.586-19.8-19.26-19.8ZM5.113 22.463c0-9.487 7.457-17.11 16.572-17.11 9.116 0 16.573 7.623 16.573 17.11v13.3c0 1.43-1.415 2.225-2.519 1.655a6.396 6.396 0 0 0-6.566.42 3.71 3.71 0 0 1-4.225 0l-.632-.434a4.632 4.632 0 0 0-5.26 0l-.633.433a3.71 3.71 0 0 1-4.225 0 6.396 6.396 0 0 0-6.566-.42c-1.106.57-2.52-.225-2.52-1.655v-13.3Z"
      clipRule="evenodd"
    />
  </svg>
)
export default Horror